import React, { useState } from "react";
import { Table, Form, Button } from "react-bootstrap";
import axios from "axios";
import { useSelector } from "react-redux";

const Journal = () => {
  const auth = useSelector((state) => state.authentication);
  const {userData} = auth;
  const [entries, setEntries] = useState([
    { date: "", account: "", type: "debit", amount: "" }
  ]);

  const handleChange = (i, field, value) => {
    const updated = [...entries];
    updated[i][field] = value;
    setEntries(updated);
  };

  const addRow = () => {
    setEntries([...entries, { date: "", account: "", type: "debit", amount: "" }]);
  };

 const saveEntries = async () => {
  try {
    await axios.post(
      `${process.env.REACT_APP_COLLEGE_ERP_API}accounts/journal`,
      {
        branch: userData.branch, // IMPORTANT
        entries: entries,
      },
      {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
      }
    );

    alert("Saved successfully");

  } catch (err) {
    console.error(err);
    alert(err.response?.data?.error || "Error saving journal");
  }
};
    
  return (
    <div className="container mt-4">
      <h3>Journal Entries</h3>

      <Table bordered>
        <thead>
          <tr>
            <th>Date</th>
            <th>Account</th>
            <th>Type</th>
            <th>Amount</th>
          </tr>
        </thead>

        <tbody>
          {entries.map((row, i) => (
            <tr key={i}>
              <td>
                <Form.Control type="date"
                  onChange={(e) => handleChange(i, "date", e.target.value)} />
              </td>
              <td>
                <Form.Control type="text"
                  onChange={(e) => handleChange(i, "account", e.target.value)} />
              </td>
              <td>
                <Form.Select
                  onChange={(e) => handleChange(i, "type", e.target.value)}>
                  <option value="debit">Debit</option>
                  <option value="credit">Credit</option>
                </Form.Select>
              </td>
              <td>
                <Form.Control type="number"
                  onChange={(e) => handleChange(i, "amount", e.target.value)} />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Button onClick={addRow}>Add Row</Button>
      <Button onClick={saveEntries} className="ms-2">Save</Button>
    </div>
  );
};

export default Journal;